import React, { memo } from "react";
import { toast } from "react-toastify";

function Checkbox({
  selectHandler,
  getDietRecipes,
  removeDietRecipes,
  item,
  index,
  checked,
  chartArray,
}) {
  return (
    <input
      type="checkbox"
      style={{
        height: 20,
        width: 20,
        marginLeft: 20,
      }}
      checked={checked ? true : false}
      onChange={(e) => {
        const hasChartArray = Array.isArray(chartArray);
        const isMaxLimit = hasChartArray && chartArray.length >= 7;

        if (e.target.checked) {
          if (isMaxLimit) {
            toast.warning("You can select a maximum of 7 diet charts.");
            selectHandler(item, false, index);
            return;
          }

          selectHandler(item, true, index);

          if (getDietRecipes) {
            getDietRecipes(item);
          }
        } else {
          selectHandler(item, e.target.checked, index);
          if (removeDietRecipes) {
            removeDietRecipes(item);
          }
        }
      }}
    />
  );
}

export default memo(Checkbox);
